export default __webpack_public_path__ + "static/media/icons8-search.1becf074.svg";